import React from "react";
import HomeInformationsComponent from "./home-informations.component";
import HomeWhoWeAreComponent from "./home-who-we-are.component";
import ContactComponent from "../_shared/contact/contact.component";
import HomeButtonsComponent from "./home-buttons.component";
import {useWindowWidth} from "../hooks/window.hook";
import {images, restaurant} from "../../assets/data/carousel.data";
import SwiperImagesComponent from "../swiper/swiper-images.component";
import {useTranslation} from "react-i18next";
import SwiperNewsComponent from "../swiper/swiper-news.component";
// import InstagramFeedComponent from "../instagram/instagram-feed.component";

export default function HomeComponent() {
    const {t} = useTranslation();

    const width = useWindowWidth();
    const breakpoint = 720;

    return (
        <div className="d-f-c-c bg-s">
            <div className="relative w-full flex flex-col items-center gap-6">
                <div
                    className="bg-backgroundSecondary text-black absolute top-4 left-1/2 -translate-x-1/2 z-[5] px-2 py-2 rounded-lg">
                    <h2 className=" w-fit border-y border-y-black whitespace-nowrap">{t("HOME.RESTAURANT")}</h2>
                </div>

                <div className="w-full">
                    <SwiperImagesComponent images={restaurant}/>

                    {/*<p className="w-full font-semibold p-4 text-center text-xl italic">Une équipe chaleureuse qui a à*/}
                    {/*    cœur de vous partager son secret le mieux gardé : une cuisine italienne intime & savoureuse au*/}
                    {/*    sein d’un cadre caché</p>*/}
                </div>
            </div>

            <HomeButtonsComponent type="home" isMobile={width < breakpoint}/>

            <div className="w-full">
                <SwiperNewsComponent isMobile={width < breakpoint}/>
            </div>

            {/* <InstagramFeedComponent isMobile={width < breakpoint}/> */}

            {width < breakpoint ? <>
                    <div className="w-full">
                        <SwiperImagesComponent images={images}/>
                    </div>

                    <div className="w-v-90">
                        <HomeInformationsComponent
                            color="bg-s"
                            border="b-h-s"
                            isMobile={width < breakpoint}
                        />
                    </div>

                    <div className="w-v-90 m-t-20">
                        <HomeWhoWeAreComponent color="bg-backgroundSecondary text-foregroundSecondary" border="b-h-p"/>
                    </div>

                    <div className="w-v-90 m-t-20">
                        <ContactComponent color="bg-s" border="b-h-s" font="f-s"/>
                    </div>
                </>
                : <>
                    <div className="mi-w-p-90 d-f-r-sb">
                        <HomeInformationsComponent
                            width="w-full"
                            color="bg-s"
                            border="border-t border-b border-white"
                            isMobile={width < breakpoint}
                        />
                    </div>

                    <div className="w-full flex items-center justify-center gap-6">
                        <div className="w-1/2 h-full">
                            <SwiperImagesComponent images={images}/>
                        </div>

                        <div className="w-1/2 flex flex-col items-center pr-6 gap-6 m-t-20">
                            <div className="w-full">
                                <HomeWhoWeAreComponent color="bg-backgroundSecondary text-foregroundSecondary"
                                                       border="b-h-p"/>
                            </div>

                            <div className="w-full">
                                <ContactComponent color="bg-s" border="b-h-s" font="f-s"/>
                            </div>
                        </div>
                    </div>
                </>
            }
        </div>
    );
}
